import { c as r } from "../../../index-34b1f277.js";
import { LayoutSwitcherAnatomy as o } from "./LayoutSwitcher.anatomy.es.js";
const { defineMultiStyleConfig: e, definePartsStyle: i } = r(
  o.keys
), t = i({
  checkbox: {
    svg: {
      color: "primary.300"
    },
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: "full",
    width: "size-400",
    height: "size-400",
    _checked: {
      svg: {
        color: "primary.700"
      },
      backgroundColor: "white",
      _hover: {
        svg: {
          color: "primary.700"
        },
        backgroundColor: "white"
      }
    },
    _hover: {
      svg: { color: "primary.300" },
      backgroundColor: "primary.100"
    },
    _disabled: {
      _hover: { backgroundColor: "primary.50" },
      cursor: "not-allowed",
      svg: {
        color: "primary.200"
      }
    }
  },
  container: {
    display: "inline-flex",
    backgroundColor: "primary.50",
    spacing: 0,
    borderRadius: "full",
    padding: "spacing-50"
  },
  icon: {
    boxSize: "size-200"
  }
}), n = e({
  baseStyle: t
});
export {
  n as LayoutSwitcher
};
//# sourceMappingURL=LayoutSwitcher.es.js.map
